import { RECEIVE_PRODUCTS } from '../productList/productListConstants';

const defaultState = { allIds: [], byId: {}, itemsByUid: {} };
const availableFacets = (state = defaultState, action) => {
  switch (action.type) {
    case RECEIVE_PRODUCTS: {
      if (!action.willUpdateAvailableFacets) {
        return state;
      }
      const facetsMetadata = action.searchMetadata.facets;
      return facetsMetadata.reduce(
        (acc, facet) => {
          if (facet.values?.length > 1) {
            acc.allIds.push(facet.id);
          }
          acc.byId[facet.id] = {
            id: facet.id,
            name: facet.name,
            nameEn: facet.nameEn,
            items: facet.values.map(value => value.id),
          };
          acc.itemsByUid = {
            ...acc.itemsByUid,
            ...facet.values.reduce((items, item) => {
              const itemUid = `${facet.id}:${item.id}`;
              return {
                ...items,
                [itemUid]: {
                  uid: itemUid,
                  id: item.id,
                  count: item.count,
                  name: item.name,
                  title: item.title,
                  facetImage: item.facetImage,
                  facet: facet.id,
                },
              };
            }, {}),
          };
          return acc;
        },
        { allIds: [], byId: {}, itemsByUid: {} }
      );
    }
    default:
      return state;
  }
};

export const getAllById = state => state.byId;
export const getItemIdsPerFacet = state =>
  state.allIds.reduce((acc, facetId) => ({ ...acc, [facetId]: state.byId[facetId].items }), {});
export const getFacetItemByUid = (state, uid) => state.itemsByUid[uid]; // include nameEn ?
export const getFacetNameEn = (state, facetId) => state.byId[facetId].nameEn;
export const getFacetIds = state => state.allIds;
export const getFacet = (state, id) => {
  const facet = state.byId[id];
  const facetItems = facet.items.map(itemId => state.itemsByUid[`${id}:${itemId}`]);
  return { ...facet, items: facetItems };
};

export default availableFacets;
